import EntityModel from '@/common/models/entity-model';

export default class PaymentInstrumentModel extends EntityModel {
    static Methods = {
        ach: 'ach',
        cash: 'cash',
        check: 'check',
        paymentCard: 'payment-card',
        paypal: 'paypal',
    };

    static getPaymentMethod({
        bin, pan, routingNumber, username, receivedBy, method,
    }) {
        if (bin || pan) {
            return PaymentInstrumentModel.Methods.paymentCard;
        }
        if (routingNumber) {
            return PaymentInstrumentModel.Methods.ach;
        }
        if (username) {
            return PaymentInstrumentModel.Methods.paypal;
        }
        if (receivedBy) {
            return PaymentInstrumentModel.Methods.cash;
        }
        if (method) {
            return PaymentInstrumentModel.Methods[method];
        }
        return null;
    }

    getMethod() {
        return PaymentInstrumentModel.getPaymentMethod({...this});
    }

    get isEmpty() {
        return !this.id;
    }

    getPayload() {
        if (this.method === PaymentInstrumentModel.Methods.ach) {
            return {
                method: this.method,
                bankAccountId: this.bankAccountId,
                gatewayAccountId: this.gatewayAccountId,
            };
        }
        if (this.method === PaymentInstrumentModel.Methods.cash) {
            return {
                method: this.method,
                receivedBy: this.receivedBy,
            };
        }
        if (this.method === PaymentInstrumentModel.Methods.paymentCard) {
            return {
                method: this.method,
                paymentCardId: this.paymentCardId,
                gatewayAccountId: this.gatewayAccountId,
            };
        }
        if (this.method === PaymentInstrumentModel.Methods.check) {
            return {
                method: this.method,
                reference: this.reference,
            };
        }
        return {
            method: this.method,
            payPalAccountId: this.payPalAccountId,
            gatewayAccountId: this.gatewayAccountId,
        };
    }

    hydrate({
        method = null,
        bankAccountId = null,
        gatewayAccountId = null,
        receivedBy = null,
        paymentCardId = null,
        payPalAccountId = null,
        reference = null,
        ...otherFields
    } = {}) {
        this.method = method;
        if (this.method === PaymentInstrumentModel.Methods.ach) {
            this.bankAccountId = bankAccountId;
            this.gatewayAccountId = gatewayAccountId;
        } else if (this.method === PaymentInstrumentModel.Methods.cash) {
            this.receivedBy = receivedBy;
        } else if (this.method === PaymentInstrumentModel.Methods.paymentCard) {
            this.paymentCardId = paymentCardId;
            this.gatewayAccountId = gatewayAccountId;
        } else if (this.method === PaymentInstrumentModel.Methods.paypal) {
            this.payPalAccountId = payPalAccountId;
            this.gatewayAccountId = gatewayAccountId;
        } else if (this.method === PaymentInstrumentModel.Methods.check) {
            this.reference = reference;
        }
        Object.assign(this, otherFields);
    }
}
